import React, { Component } from "react";
import Paper from "@mui/material/Paper";
import {
  Checkbox,
  Divider,
  FormControlLabel,
  TextField,
  List,
  ListItem,
} from "@mui/material";
import "./css/InverterSelectorForm.css";
import { Card, CardHeader, CardContent } from "@mui/material";

export class OptionSelectView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalcap4IS: "",
      phase4IS: "",
      inputVolt4IS: "",
      shakerTableHide: false,
      optionData: this.props.optionList,
      batListData: this.props.batteryList,
      monitorOptionsList: this.props.monitorOptions,
      batteryMonitorList: this.props.batMonList,
      systemTransferList: this.props.systemTransfer,
      globMonitorList: this.props.globMonList,
      ready2Save: false,
      qtyMonOption: this.props.qtyMonOption,
    };
  }

  saveOptionList = (event) => {
    console.log("Save Option List this calls Set OptionsList");
    //this.props.setOptionsList(event.target.value, event.target.checked)

    this.setState(
      (prevState) => ({
        optionData: {
          ...prevState.optionData,
          [event.target.value]: !prevState.optionData[event.target.value],
        },
      }),
      () => {
        this.props.setOptionsList(this.state.optionData);
      }
    );
  };

  saveBatOptionList = (event) => {
    this.setState(
      (prevState) => ({
        batListData: {
          ...prevState.batListData,
          [event.target.value]: !prevState.batListData[event.target.value],
        },
      }),
      () => {
        this.props.setBatOptionsList(this.state.batListData);
      }
    );
  };

  saveBatMonitorOptionList = (event) => {
    this.setState(
      (prevState) => ({
        batteryMonitorList: {
          ...prevState.batteryMonitorList,
          [event.target.value]:
            !prevState.batteryMonitorList[event.target.value],
        },
      }),
      () => {
        this.props.setBatMonOptionsList(this.state.batteryMonitorList);
      }
    );
  };

  saveMonitorOptionsList = (event) => {
    this.setState(
      (prevState) => ({
        monitorOptionsList: {
          ...prevState.monitorOptionsList,
          [event.target.value]:
            !prevState.monitorOptionsList[event.target.value],
        },
      }),
      () => {
        this.props.setMonOptionsList(this.state.monitorOptionsList);
      }
    );
  };

  saveSystemTransferList = (event) => {
    this.setState(
      (prevState) => ({
        systemTransferList: {
          ...prevState.systemTransferList,
          [event.target.value]:
            !prevState.systemTransferList[event.target.value],
        },
      }),
      () => {
        //console.log("Finished updating systemTransferList")
        //console.log(this.state.systemTransferList)

        this.props.setSystemTransfer(this.state.systemTransferList);
      }
    );
  };

  saveGlobalMonList = (event) => {
    this.setState(
      (prevState) => ({
        globMonitorList: {
          ...prevState.globMonitorList,
          [event.target.value]: !prevState.globMonitorList[event.target.value],
        },
      }),
      () => {
        //console.log("Finished updating setGlobalMonList")
        //console.log(this.state.globMonitorList)

        this.props.setGlobalMonList(this.state.globMonitorList);
      }
    );
  };

  setQTYOptions = (event) => {
    if (event.target.value < 0) {
      event.target.value = 0;
    }

    //console.log(e.target.name)
    this.setState(
      (prevState) => ({
        qtyMonOption: {
          ...prevState.qtyMonOption,
          [event.target.name]: event.target.value,
        },
      }),
      () => {
        //console.log("Finished updating Monitor Option")
        //console.log(this.state.qtyMonOption)

        this.props.setQtyMonOptionsList(this.state.qtyMonOption);
      }
    );
  };
  getQuantityOptions = (optionData) => {
    //console.log(optionData)
    const quantityFields = [];

    for (const key in optionData) {
      if (!optionData[key] && key.includes("Load Control Relay")) {
        //console.log(key)
        quantityFields.push(<span>{key}</span>);

        quantityFields.push(
          <TextField
              InputLabelProps={{ style: { fontFamily: 'Ford-Normal' } }} // font size of input label
                          name={"QUANT* " + key}
            type="number"
            label={"How Many?"}
            defaultValue={this.state.qtyMonOption["QUANT* " + key]}
            onChange={this.setQTYOptions}
          ></TextField>
        );
        quantityFields.push(<br />);
      }
    }
    return quantityFields;
  };
  render() {
    return (
      //App starts here
      <Card elevation={10}>
        <CardHeader
          titleTypographyProps={{
            fontFamily: 'Ford-Normal',
          }}
          className="paperh-title"
          title={"Options for " + this.props.data.productType}
        />
        <CardContent>
          {Object.keys(this.state.optionData).length !== 0 && (
            <Paper elevation={5}>
              <CardHeader
          titleTypographyProps={{
            fontFamily: 'Ford-Normal',
          }} title="Additional Options"> </CardHeader>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginTop: "15px",
                  marginBottom: "15px",
                  fontFamily: "Ford-Normal"
                }}
              >
                <List>
                  {Object.keys(this.state.optionData).map((item, index) => {
                    if (item.includes("QUANT*")) return "";

                    return (
                      <ListItem key={index}>
                        <Card variant="">
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={!this.state.optionData[item]}
                                value={item}
                                onChange={this.saveOptionList}
                              />
                            }
                            label={
                              item.includes("Transient")
                                ? "TVSS ~ " + item
                                : item
                            }
                            sx={{ '& .MuiTypography-root': { fontFamily: 'Ford-Normal' } }}
                          />
                        </Card>
                      </ListItem>
                    );
                  })}
                </List>
                <Divider orientation="vertical" flexItem />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    padding: "8px",
                    alignSelf: "start",
                    marginLeft: "20px",
                    marginRight: "auto",
                  }}
                >
                  {this.getQuantityOptions(this.state.optionData)}
                </div>
              </div>
            </Paper>
          )}
          {Object.keys(this.state.batListData).length !== 0 && (
            <Paper elevation={5}>
              <CardHeader
          titleTypographyProps={{
            fontFamily: 'Ford-Normal',
          }} title="Battery Options"> </CardHeader>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginTop: "15px",
                  marginBottom: "15px",
                }}
              >
                <List>
                  {Object.keys(this.state.batListData).map((item, index) => (
                    <ListItem key={index}>
                      <Card variant="">
                        <FormControlLabel
                          control={
                            <Checkbox
                              
                              checked={!this.state.batListData[item]}
                              value={item}
                              onChange={this.saveBatOptionList}
                            />
                          }
                          label={item}
                          sx={{ '& .MuiTypography-root': { fontFamily: 'Ford-Normal' } }}
                        />
                      </Card>
                    </ListItem>
                  ))}
                </List>
              </div>
            </Paper>
          )}
          {Object.keys(this.state.monitorOptionsList).length !== 0 && (
            <Paper elevation={5}>
              <CardHeader
          titleTypographyProps={{
            fontFamily: 'ford-normal',
          }} title="Monitoring Options"> </CardHeader>
              {this.props.data.productType !== "Micro Power Wave" &&
                this.props.data.productType !== "Mini Power Wave" && (
                  <CardContent>
                    "*** Disclaimer: You must select only one between RS232, Dry
                    Contacts Open Signal, Dry Contacts Closed Signal, Dual
                    Contact Open and Closed"{" "}
                  </CardContent>
                )}
              {(this.props.data.productType === "Micro Power Wave" ||
                this.props.data.productType === "Mini Power Wave") && (
                <CardContent>
                  *** Disclaimer: You must select only one between RS232, Dry
                  Contacts and SNMP"{" "}
                </CardContent>
              )}
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginTop: "15px",
                  marginBottom: "15px",
                }}
              >
                <List id="2">
                  {Object.keys(this.state.monitorOptionsList).map(
                    (item, index) => {
                      let distinctOptions = [];

                      if (
                        this.props.data.productType !== "Micro Power Wave" &&
                        this.props.data.productType !== "Mini Power Wave"
                      ) {
                        distinctOptions = [
                          "Dry Contacts Open Signal",
                          "Dry Contacts Closed Signal",
                          "Dual, Open and Closed Dry Contact",
                          "RS232 and RS485 Connecting Port ",
                        ];
                        console.log("true")
                      } else {
                        distinctOptions = [
                          "Dry Contact",
                          "RS~232",
                          "SNMP ~ Remote Log Access",
                        ];
                      }

                      console.log(this.state.monitorOptionsList)
                      console.log(distinctOptions)

                      const distinctOptionsSelected = [];
                      Object.keys(this.state.monitorOptionsList).map(
                        (item, index) => {
                          if (
                            !this.state.monitorOptionsList[item] &&
                            distinctOptions.includes(item)
                          )
                            distinctOptionsSelected.push(item);
                        }
                      );
                      console.log(distinctOptionsSelected);
                      console.log(item);
                      var disabled =
                        distinctOptions.includes(item) &&
                        distinctOptionsSelected.length > 0 &&
                        item !== distinctOptionsSelected[0];
                      return (
                        <ListItem key={index}>
                          <Card variant="">
                            <FormControlLabel
                            
                              control={
                                <Checkbox
                                  // disabled={true}
                                  disabled={disabled}
                                  checked={!this.state.monitorOptionsList[item]}
                                  value={item}
                                  onChange={this.saveMonitorOptionsList}
                                >
                                  
                                </Checkbox>
                              }
                              label={item}
                              sx={{ '& .MuiTypography-root': { fontFamily: 'Ford-Normal' } }}
                            />
                          </Card>
                        </ListItem>
                      );
                    }
                  )}
                </List>
              </div>
            </Paper>
          )}
          {Object.keys(this.state.systemTransferList).length !== 0 && (
            <Paper elevation={5}>
              <CardHeader
          titleTypographyProps={{
            fontFamily: 'ford-normal',
          }} title="System Transfer"> </CardHeader>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginTop: "15px",
                  marginBottom: "15px",
                }}
              >
                <List>
                  {Object.keys(this.state.systemTransferList).map(
                    (item, index) => (
                      <ListItem key={index}>
                        <Card variant="">
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={!this.state.systemTransferList[item]}
                                value={item}
                                onChange={this.saveSystemTransferList}
                              />
                            }
                            label={item}
                            sx={{ '& .MuiTypography-root': { fontFamily: 'Ford-Normal' } }}
                          />
                        </Card>
                      </ListItem>
                    )
                  )}
                </List>
              </div>
            </Paper>
          )}
          {Object.keys(this.state.batteryMonitorList).length !== 0 && (
            <Paper elevation={5}>
              <CardHeader
          titleTypographyProps={{
            fontFamily: 'ford-normal',
          }} title="Battery Monitoring"></CardHeader>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginTop: "15px",
                  marginBottom: "15px",
                }}
              >
                <List>
                  {Object.keys(this.state.batteryMonitorList).map(
                    (item, index) => (
                      <ListItem key={index}>
                        <Card variant="">
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={!this.state.batteryMonitorList[item]}
                                value={item}
                                onChange={this.saveBatMonitorOptionList}
                              />
                            }
                            label={item}
                            sx={{ '& .MuiTypography-root': { fontFamily: 'Ford-Normal' } }}
                          />
                        </Card>
                      </ListItem>
                    )
                  )}
                </List>
              </div>
            </Paper>
          )}
          {Object.keys(this.props.globMonList).length !== 0 && (
            <Paper elevation={5}>
              <CardHeader
          titleTypographyProps={{
            fontFamily: 'ford-normal',
          }} title="Global Monitoring"></CardHeader>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginTop: "15px",
                  marginBottom: "15px",
                }}
              >
                <List>
                  {Object.keys(this.props.globMonList).map((item, index) => {
                    const monitoringMegaOption =
                      "Testing Logs with Remote Accessibility Through Local Network and GPRS for Cellular Text Alerts";
                    const disabled =
                      !this.state.globMonitorList[monitoringMegaOption] &&
                      item !== monitoringMegaOption;
                    if (disabled) this.state.globMonitorList[item] = true;
                    return (
                      <ListItem key={index}>
                        <Card variant="">
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={
                                  !this.props.globMonList[item] && !disabled
                                }
                                value={item}
                                disabled={disabled}
                                onChange={this.saveGlobalMonList}
                              />
                            }
                            label={item}
                            sx={{ '& .MuiTypography-root': { fontFamily: 'Ford-Normal' } }}
                          />
                        </Card>
                      </ListItem>
                    );
                  })}
                </List>
              </div>
            </Paper>
          )}
        </CardContent>
      </Card>
    );
  }
}

export default OptionSelectView;
